
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import $ from 'jquery';

const FpsDetailsForm = ({ data, fpsId, restoredFormData, setRestoredFormData, setShowSuccess, setSuccessData, setShowDetailsF, onBack }) => {
  const { list, fps_name, fps_maintain_by, terminal_id, district, check, weighing_mac_id, latitude, longitude } = data;
  const [options, setOptions] = useState('');
  const [suggestions, setSuggestions] = useState({});
  const [autoSuggestionsList, setAutoSuggestionsList] = useState({});
  const [showSuggestionsUid, setShowSuggestionsUid] = useState({});
  const [showAutoSuggestionsUid, setShowAutoSuggestionsUid] = useState({});
  const [suggestionsDevice, setSuggestionsDevice] = useState(false);
  const [autoSuggestionsDevice, setAutoSuggestionsDevice] = useState('');
  const [showSuggestionsDevice, setShowSuggestionsDevice] = useState(false);
  const [showAutoSuggestionsDevice, setShowAutoSuggestionsDevice] = useState(false);
  const [error, setError] = useState({});
  const [uidMap, setUidMap] = useState({});
  const [mobileError, setMobileError] = useState({});
  
const [latitudeError, setLatitudeError] = useState(''); 
const [longitudeError, setLongitudeError] = useState('');
  
  const initialFpsName = restoredFormData?.fps_name || ((fps_name === "" || fps_name == null) ? "NA" : fps_name);
  const initialTerminalId = restoredFormData?.terminal_id || (terminal_id === "null" ? "" : terminal_id);
  const initialMacId = restoredFormData?.mac_id || (weighing_mac_id || "");
  
  const initialLatitude = restoredFormData?.latitude || (latitude === null || latitude === "" ? "NA" : latitude);
const initialLongitude = restoredFormData?.longitude || (longitude === null || longitude === "" ? "NA" : longitude);
  const initialFpsMaintainBy = restoredFormData?.fps_maintain_by || fps_maintain_by;

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_URL}/api/fps-details/put-option?tab=common.mst_fps_maintain&code=fps_maintain_by&name=fps_maintain&selected=${initialFpsMaintainBy}`,
          { withCredentials: true }
        );
        setOptions(res.data);
      } catch (e) {
        console.error('Failed to load options:', e);
        setOptions('<option value="P">Private</option><option value="C">Co-Operative</option><option value="G">Government</option>');
      }
    };
    fetchOptions();
  }, [initialFpsMaintainBy]);

  useEffect(() => {
    if (restoredFormData && restoredFormData.del_uid) {
      const newUidMap = {};
      restoredFormData.del_uid.forEach((uid, index) => {
        if (uid && uid.length === 12) {
          const dealerType = restoredFormData.dealer_type?.[index];
          if (dealerType) {
            newUidMap[uid] = dealerType;
          }
        }
      });
      setUidMap(newUidMap);
    } else {
      const newUidMap = {};
      list.forEach(item => {
        if (item.dealerUid && item.dealerUid.length === 12) {
          newUidMap[item.dealerUid] = item.dealerType;
        }
      });
      setUidMap(newUidMap);
    }
  }, [restoredFormData, list]);
const validateLatitude = (value) => {
  if (!value || value.trim() === "" || value === "NA") {
    setLatitudeError("Latitude value is required");
    document.getElementById('latitude').style.border = "1px solid red";
  } else {
    setLatitudeError("");
    document.getElementById('latitude').style.border = "";
  }
};

const validateLongitude = (value) => {
  if (!value || value.trim() === "" || value === "NA") {
    setLongitudeError("Longitude value is required");
    document.getElementById('longitude').style.border = "1px solid red";
  } else {
    setLongitudeError("");
    document.getElementById('longitude').style.border = "";
  }
};
  const validateForm = () => {
    const fpsMaintainByEl = document.getElementById('fps_maintain_by');
    const fpsNameEl = document.getElementById('fps_name');
    const macIdEl = document.getElementById('mac_id');
    
  const latitudeEl = document.getElementById('latitude');
  const longitudeEl = document.getElementById('longitude');

    if (!fpsMaintainByEl.value || fpsMaintainByEl.value.length === 0) {
      alert("Enter Dealer Type");
      fpsMaintainByEl.focus();
      fpsMaintainByEl.style.border = "1px solid red";
      return false;
    }

    if (!fpsNameEl.value || fpsNameEl.value.length === 0) {
      alert("Enter FPS Name");
      fpsNameEl.focus();
      fpsNameEl.style.border = "1px solid red";
      return false;
    }

const latitudeVal = latitudeEl.value.trim();
  if (!latitudeVal || latitudeVal === "NA") {
    setLatitudeError("Latitude value is required");
    latitudeEl.focus();
    latitudeEl.style.border = "1px solid red";
    return false;
  } else {
    setLatitudeError("");
    latitudeEl.style.border = "";
  }

  const longitudeVal = longitudeEl.value.trim();
  if (!longitudeVal || longitudeVal === "NA") {
    setLongitudeError("Longitude value is required");
    longitudeEl.focus();
    longitudeEl.style.border = "1px solid red";
    return false;
  } else {
    setLongitudeError("");
    longitudeEl.style.border = "";
  }
    const delNameInputs = document.querySelectorAll('input[name="del_name"]');
    const delUidInputs = document.querySelectorAll('input[name="del_uid"]');
    const delMobInputs = document.querySelectorAll('input[name="del_mob"]');

    let hasErrors = false;

    for (let i = 0; i < delNameInputs.length; i++) {
      const uidVal = delUidInputs[i].value.trim();
      const mobVal = delMobInputs[i].value.trim();
      const dealerType = list[i]?.dealerType;

      if (uidVal && uidVal.length !== 12) {
        setError(prev => ({ ...prev, [dealerType]: "Value must be 12 digits" }));
        delUidInputs[i].focus();
        delUidInputs[i].style.border = "1px solid red";
        hasErrors = true;
      }

      if (mobVal && mobVal.length !== 10) {
        setMobileError(prev => ({ ...prev, [dealerType]: "Mobile number must be 10 digits" }));
        delMobInputs[i].focus();
        delMobInputs[i].style.border = "1px solid red";
        hasErrors = true;
      } else if (mobVal && !/^[6-9]/.test(mobVal)) {
        setMobileError(prev => ({ ...prev, [dealerType]: "Mobile number should start with 6, 7, 8, or 9" }));
        delMobInputs[i].focus();
        delMobInputs[i].style.border = "1px solid red";
        hasErrors = true;
      }
    }

    return !hasErrors;
  };

  const check_uid = async (inputString, idT, currentDealerType) => {
    if (inputString.length < 12) {
      setSuggestions(prev => ({ ...prev, [idT]: true }));
      setShowAutoSuggestionsUid(prev => ({ ...prev, [idT]: false }));
    } else {
      setSuggestions(prev => ({ ...prev, [idT]: false }));
      try {
        const res = await axios.get(`${process.env.REACT_APP_URL}/api/fps-details/check-uid?uid=${inputString}`, { withCredentials: true });
        setAutoSuggestionsList(prev => ({ ...prev, [idT]: res.data }));
        setShowAutoSuggestionsUid(prev => ({ ...prev, [idT]: true }));
      } catch (err) {
        setAutoSuggestionsList(prev => ({ ...prev, [idT]: 'Error' }));
        setShowAutoSuggestionsUid(prev => ({ ...prev, [idT]: true }));
      }
    }
  };

  const check_device = async (inputString) => {
    if (inputString.length < 10) {
      setShowSuggestionsDevice(true);
      setShowAutoSuggestionsDevice(false);
    } else {
      setShowSuggestionsDevice(false);
      try {
        const res = await axios.get(`${process.env.REACT_APP_URL}/api/fps-details/check-device?device=${inputString}`, { withCredentials: true });
        setAutoSuggestionsDevice(res.data);
        setShowAutoSuggestionsDevice(true);
      } catch (err) {
        setAutoSuggestionsDevice('Error');
        setShowAutoSuggestionsDevice(true);
      }
    }
  };

  const resetForm = () => {
    document.getElementById('terminal_id').value = "";
    document.getElementById('mac_id').value = "";
    
  document.getElementById('latitude').value = "";  
  document.getElementById('longitude').value = "";
  
  setLatitudeError('');
  setLongitudeError('');

    const delNameInputs = document.querySelectorAll('input[name="del_name"]');
    const delUidInputs = document.querySelectorAll('input[name="del_uid"]');
    const delMobInputs = document.querySelectorAll('input[name="del_mob"]');
    delNameInputs.forEach(input => input.value = "");
    delUidInputs.forEach(input => input.value = "");
    delMobInputs.forEach(input => input.value = "");
    setError({});
    setMobileError({});
    setUidMap({});
    return false;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
      document.getElementById('latitude').style.border = "";
  document.getElementById('longitude').style.border = "";
    if (!validateForm()) {
      return false;
    }
    const delName = Array.from(document.querySelectorAll('input[name="del_name"]')).map(el => el.value);
    const delUid = Array.from(document.querySelectorAll('input[name="del_uid"]')).map(el => el.value);
    const delMob = Array.from(document.querySelectorAll('input[name="del_mob"]')).map(el => el.value);
    const delType = Array.from(document.querySelectorAll('input[name="dealer_type"]')).map(el => el.value);
    const terminalId = document.getElementById('terminal_id').value;
    const macId = document.getElementById('mac_id').value;
    
     const latitude = document.getElementById('latitude').value;
  const longitude = document.getElementById('longitude').value;
    const fpsName = document.getElementById('fps_name').value;
    const fpsMaintainBy = document.getElementById('fps_maintain_by').value;
    const payload = {
      del_name: delName,
      del_uid: delUid,
      del_mob: delMob,
      dealer_type: delType,
      terminal_id: terminalId,
      mac_id: macId,
       latitude: latitude, 
    longitude: longitude,
      fps_id: fpsId,
      fps_name: fpsName,
      fps_maintain_by: fpsMaintainBy
    };
    setRestoredFormData(payload);
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL}/api/fps-details/upsert`, payload, { withCredentials: true });
      if (res.data.message === "Session Expired") {
      alert("Session Expired");
      return false;
    }
      setShowSuccess({ formData: payload, response: res.data });
    } catch (err) {
      console.error('Submission error:', err);
      if (err.response?.data?.message === "Session Expired") {
      alert("Session Expired");
      return false;
    }
      const errorMsg = err.response?.data?.message || 'Update failed. Please try again.';
      const errorResponse = { message: errorMsg, fps_id: fpsId };
      setShowSuccess({ formData: payload, response: errorResponse });
    }
    return false;
  };

  const NumericsOnly = (event) => {
    if ((event.which != 8 && event.which != 0 && (event.which < 48 || event.which > 57))) {
      event.preventDefault();
    }
  };

  const handleDeviceKeyUp = initialTerminalId.length === 0 ? check_device : undefined;

  if (check === 0) {
    return <div align="center"><div className="response">Given FPS Details Not Found</div></div>;
  }
  
  const validateMobileNumber = (value, dealerType) => {
    if (value.length > 0) {
      if (value.length !== 10) {
        setMobileError(prev => ({
          ...prev,
          [dealerType]: "Mobile number must be 10 digits"
        }));
      } else if (!/^[6-9]/.test(value)) {
        setMobileError(prev => ({
          ...prev,
          [dealerType]: "Mobile number should start with 6, 7, 8, or 9"
        }));
      } else {
        setMobileError(prev => ({
          ...prev,
          [dealerType]: ""
        }));
      }
    } else {
      setMobileError(prev => ({
        ...prev,
        [dealerType]: ""
      }));
    }
  };

  const validateUidNumber = (value, dealerType) => {
    if (value && value.length > 0 && value.length !== 12) {
      setError(prev => ({ ...prev, [dealerType]: 'Value must be 12 digits' }));
    } else {
      setError(prev => ({ ...prev, [dealerType]: '' }));
    }
  };

  return (
    <form name="fname" onSubmit={handleSubmit} noValidate> 
      <table width="40%" align="center">
        <tbody>
          <tr className="tableheader"><th colSpan="2">FPS Details</th></tr>
          <tr><td>FPS Name</td><td><input type="text" required name="fps_name" id="fps_name" defaultValue={initialFpsName} style={{ backgroundColor: 'white' }} /></td></tr>
          <tr><td>FPS Dealer Type</td><td><select name="fps_maintain_by" id="fps_maintain_by" dangerouslySetInnerHTML={{ __html: options }} style={{ backgroundColor: 'white' }} /></td></tr>
          <tr><td>Device No</td><td>
            <input type="hidden" name="fps_id" id="fps_id" value={fpsId} />
            <input type="hidden" name="district" id="district" value={district} />
            <input
              type="text"
              name="terminal_id"
              id="terminal_id"
              onKeyUp={(e) => handleDeviceKeyUp && handleDeviceKeyUp(e.target.value)}
              maxLength="16"
              defaultValue={initialTerminalId}
              style={{ backgroundColor: 'white' }}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^a-zA-Z0-9]/g, '');
              }}
            />
            <font color="red">
              <div id="suggestions3" style={{ display: showSuggestionsDevice ? 'block' : 'none' }}></div>
              <div style={{ display: showAutoSuggestionsDevice ? 'block' : 'none' }} id="autoSuggestionsList3">
                {autoSuggestionsDevice}
              </div>
            </font>
          </td></tr>

          <tr><td>Weighing Scale Mac ID</td><td>
            <input
              type="text"
              name="mac_id"
              id="mac_id"
              defaultValue={initialMacId}
             
              style={{ backgroundColor: 'white' }}
            />
          </td></tr>
          {/* latitude */}
          <tr>
  <td>Latitude</td>
  <td>
    <input
      type="text"
      name="latitude"
      id="latitude"
      defaultValue={initialLatitude}
      style={{ 
        backgroundColor: 'white',
        border: latitudeError ? '1px solid red' : ''
      }}
      onInput={(e) => {
      }}
      onBlur={(e) => validateLatitude(e.target.value)} 
    />
    {latitudeError && (
      <div style={{ color: 'red', fontSize: '12px' }}>{latitudeError}</div>
    )}
  </td>
</tr>
<tr>
  <td>Longitude</td>
  <td>
    <input
      type="text"
      name="longitude"
      id="longitude"
      defaultValue={initialLongitude}
      style={{ 
        backgroundColor: 'white',
        border: longitudeError ? '1px solid red' : ''
      }}
      onInput={(e) => {
      }}
      onBlur={(e) => validateLongitude(e.target.value)} //
    />
    {longitudeError && (
      <div style={{ color: 'red', fontSize: '12px' }}>{longitudeError}</div>
    )}
  </td>
</tr>

          {list.map((bean, index) => (
            <React.Fragment key={bean.dealerType || index}>
              <tr><td>{bean.dealerTypeName} Name</td><td>
                <input
                  type="text"
                  name="del_name"
                  id="del_name"
                  defaultValue={restoredFormData ? (restoredFormData.del_name?.[index] || bean.dealerNameEn) : bean.dealerNameEn}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^a-zA-Z.\s]/g, '');
                  }}
                  style={{ backgroundColor: 'white' }}
                />
              </td></tr>
              <tr><td>{bean.dealerTypeName} UID</td><td>
                <input
                  type="text"
                  onKeyUp={(e) => check_uid(e.target.value, bean.dealerType, bean.dealerType)}
                  name="del_uid"
                  maxLength="12"
                  id="del_uid"
                  onKeyPress={NumericsOnly}
                  onChange={(e) => validateUidNumber(e.target.value, bean.dealerType)}
                  defaultValue={restoredFormData ? (restoredFormData.del_uid?.[index] || bean.dealerUid) : bean.dealerUid}
                  style={{
                    backgroundColor: 'white',
                    border: error[bean.dealerType] ? '1px solid red' : ''
                  }}
                />
                {error[bean.dealerType] && (
                  <div style={{ color: 'red', fontSize: '12px' }}>{error[bean.dealerType]}</div>
                )}
                <font color="red">
                  <div id={`suggestions${bean.dealerType}`} style={{ display: suggestions[bean.dealerType] ? 'block' : 'none' }}></div>
                  <div style={{ display: showAutoSuggestionsUid[bean.dealerType] ? 'block' : 'none' }} id={`autoSuggestionsList${bean.dealerType}`}>{autoSuggestionsList[bean.dealerType]}</div>
                </font>
              </td></tr>
              <tr><td>{bean.dealerTypeName} Mobile</td><td>
                <input type="hidden" name="dealer_type" id="dealer_type" value={bean.dealerType} />
                <input
                  type="text"
                  name="del_mob"
                  maxLength="10"
                  id={`del_mob_${bean.dealerType}`}
                  onKeyPress={NumericsOnly}
                  onChange={(e) => validateMobileNumber(e.target.value, bean.dealerType)}
                  defaultValue={restoredFormData ? (restoredFormData.del_mob?.[index] || bean.dealerMobile) : bean.dealerMobile}
                  style={{
                    backgroundColor: 'white',
                    border: mobileError[bean.dealerType] ? '1px solid red' : ''
                  }}
                />
                {mobileError[bean.dealerType] && (
                  <div style={{ color: 'red', fontSize: '12px' }}>
                    {mobileError[bean.dealerType]}
                  </div>
                )}
              </td></tr>
            </React.Fragment>
          ))}
          <tr align="center">
  <td colSpan="2">
    <button type="submit" className="button button2" style={{ marginRight: "7px" }}>Submit</button>
    <button type="button" onClick={onBack} className="button button2" style={{ marginRight: "7px" }}>Back</button>
    <button type="button" onClick={resetForm} className="button button2">Clear</button>
  </td>
</tr>
        </tbody>
      </table><br></br>
      <br></br><br></br>
      <br></br><br></br>
    </form>
  );
};

export default FpsDetailsForm;